import React from "react";

import { resolveRlAggregateDriftChevron } from "../account-relationships/relationshipUtils";

export function AccountBubbleDriftChevron({ rlAggregate }) {
  const drift = resolveRlAggregateDriftChevron(rlAggregate);
  if (!drift) return null;

  return (
    <span
      className={`ab-chevron ab-chevron--${drift.direction}`}
      style={{ opacity: drift.opacity }}
      aria-hidden
    />
  );
}

export default AccountBubbleDriftChevron;
